<template>
  <div class="product-type-container">
    <h2 class="mb-3">ประเภทสินค้า</h2>
    <v-card class="pa-4 elevation-5 rounded-xl">
      <v-data-table
        :loading="isLoading"
        :headers="headers"
        :items="(producttypes && producttypes.data) || []"
        :server-items-length="producttypes && producttypes.total"
        :footer-props="{
          itemsPerPageOptions,
        }"
        :options.sync="options"
        no-data-text="ไม่พบข้อมูล"
        no-results-text="ไม่พบข้อมูล"
      >
        <template v-slot:top>
          <v-toolbar flat color="white" :height="checkScreen">
            <v-row>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="12" md="8">
                    <v-text-field
                      :disabled="isLoading"
                      v-model="keyword"
                      label="ค้นหาจาก"
                      single-line
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-btn
                      outlined
                      depressed
                      @click="searchKeyword"
                      color="#009b3f"
                      :block="checkMdScreen"
                      >ค้นหา</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <ProductTypeForm
                  class="text-right"
                  :editId="editId"
                  :dialog="modalDialog"
                  :toggleDialog="toggleDialog"
                  :setInitialDialog="setInitialDialog"
                />
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <b class="success--text">{{ item.name }}</b>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn depressed text color="success" @click="editItem(item.id)"
            ><b>แก้ไข</b></v-btn
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Utils from "@/mixin";

import { itemsPerPageOptions } from "@/plugins/common";

import ProductTypeForm from "./ProductType/Form";

export default {
  name: "Admin-ProductType",
  mixins: [Utils],
  components: {
    ProductTypeForm,
  },
  computed: {
    dataList() {
      const { itemList } = this;
      return itemList;
    },
    checkScreen() {
      const { windowWidth } = this;
      if (windowWidth >= 1440) {
        return "64px";
      } else if (windowWidth < 1440 && windowWidth >= 960) {
        return "64px";
      } else if (windowWidth < 960) {
        return "180px";
      }
      return "0px";
    },
    checkMdScreen() {
      const { windowWidth } = this;
      if (windowWidth >= 960) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.getInitialData();
      },
      deep: false,
    },
  },
  data: () => ({
    editId: "",
    modalDialog: false,
    dialog: false,
    itemList: [],
    keyword: "",
    options: {
      itemsPerPage: 50,
    },
    itemsPerPageOptions: [],
    total: 0,
    headers: [
      { text: "ชื่อประเภทสินค้า", value: "name" },
      {
        text: "ดำเนินการ",
        value: "actions",
        align: "center",
        sortable: false,
        width: "200px",
      },
    ],
    windowWidth: window.innerWidth,
  }),
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    this.itemsPerPageOptions = itemsPerPageOptions;
  },
  methods: {
    async getInitialData() {
      let condition = {};

      // filter
      if (this.keyword) {
        condition.query = this.keyword;
      }

      // paging
      {
        // Per page
        if (this.options && this.options.itemsPerPage) {
          condition.limit = this.options.itemsPerPage;
        }

        // Page
        if (this.options && this.options.page) {
          condition.page = this.options.page;
        }
      }

      // sort
      if (this.options?.sortBy?.[0]) {
        condition.order = `${this.options.sortBy[0]}:${
          this.options?.sortDesc?.[0] ? "desc" : "asc"
        }`;
      }

      await this.getProductTypes(condition);
    },
    editItem(id) {
      this.editId = id;
      this.toggleDialog();
    },
    searchKeyword() {
      this.getInitialData();
    },
    toggleDialog() {
      this.modalDialog = !this.modalDialog;
    },
    setInitialDialog() {
      this.editId = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.product-type-container {
  padding: 20px;
}
</style>